"use client"

import { be } from "@/lib/better-errors"
import { getPlanStatus, type CompanyPlanStatusFields } from "@/lib/get-plan-status"
import { createFullName } from "@/lib/helpers/text"
import { useMe } from "@/lib/hooks/use-me"
import { hotjar } from "@/lib/hotjar"
import type { BaseUserType } from "@/server/models/user/auth"
import type { Team } from "@prisma/client"
import * as Sentry from "@sentry/nextjs"
import { usePostHog } from "posthog-js/react"
import * as React from "react"

declare global {
  interface Window {
    clarity?: (action: string, id: string) => void
  }
}

type User = BaseUserType & {
  team: null | (Pick<Team, "id" | "name" | "industry" | "billingCountry" | "areUsersHidden"> & CompanyPlanStatusFields)
}

export function TrackingProviders({ user }: { user: User }) {
  const posthog = usePostHog()

  useMe({ initialData: user })

  React.useEffect(() => {
    const details = { id: user.id, email: user.email, name: createFullName(user) }

    const status = getPlanStatus(user.team)

    Sentry.setUser(details)
    be.setUser(details)
    hotjar.identify(user.id, details)
    posthog.identify(user.id, {
      ...details,
      company: user.team?.name,
      company_id: user.team?.id,
      industry: user.team?.industry,
      country: user.team?.billingCountry,
      status,
    })
    window.clarity?.("identify", details.id)
  }, [user])
  return null
}
